import { Component, forwardRef, input, output } from '@angular/core';
import { NgClass } from '@angular/common';
import { FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { AbstractFormControlComponent } from '../abstract-form-control.component';

@Component({
  selector: 'shared-ui-text',
  standalone: true,
  imports: [NgClass, FormsModule, ReactiveFormsModule],
  templateUrl: './text.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TextComponent),
      multi: true,
    },
  ],
})
export class TextComponent extends AbstractFormControlComponent<string> {
  readonly label = input<string>('');
  readonly name = input.required<string>();
  readonly placeholder = input<string>('');
  readonly warningText = input('Fehlerhafte Eingabe');
  readonly isInvalid = input<boolean>(false);

  clicked = output<void>();
}
